import { Component } from '@angular/core';
import { CountryGroupAllocationDTO } from 'src/app/core/models/system/country-group/country-group-allocation.dto';
import { CountryGroupService } from 'src/app/core/services/utelize/system/country-group/country-group-service';
import { ExceptionsService } from 'src/app/core/services/utelize/general/exceptions-service';

@Component({
  selector: 'app-country-group-countries',
  templateUrl: './country-group-countries.component.html',
  styleUrls: ['./country-group-countries.component.scss']
})

export class CountryGroupCountriesEmbeddedComponent {

  public countries     : CountryGroupAllocationDTO[] = [];
  public loadedGroupId : number | undefined;
  public loading       : boolean                     = false;

  constructor(
    private countryGroupService: CountryGroupService,
    private exceptionsService   : ExceptionsService
  ) { }

  public showCountries(groupId: number): void {
    try {
      if (groupId == undefined || groupId <= 0)
        return;

      this.loadedGroupId = groupId;
      this.loading       = true;

      this.countryGroupService.getAllCountriesForGroupId(groupId).subscribe({
        next: (rows: CountryGroupAllocationDTO[]) => {
          this.countries = (rows ?? [])
            .filter(r => r.included == true)
            .sort((a, b) => (a.countryName ?? '').localeCompare(b.countryName ?? ''));
          this.loading = false;
        },
        error: (e) => {
          this.loading = false;
          this.exceptionsService.handleException(<Error>e);
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
}
